// @ts-nocheck
import Macquarie from "../assets/icons/bank/Macquarie.jpeg";
import MembersEquityBank from "../assets/icons/bank/Members-Equity-Bank-Limited.png";
import NABBank from "../assets/icons/bank/NAB-bank.png";
import AMPBank from "../assets/icons/bank/amp.jpeg";
import ANZ from "../assets/icons/bank/anz.png";
import ArabBank from "../assets/icons/bank/arab-autralian-bank.png";
import AustralianMutualBank from "../assets/icons/bank/aus-mutual-bank.jpeg";
import AustralianMilitaryBank from "../assets/icons/bank/australian-military.png";
import AustralianUnityBank from "../assets/icons/bank/australian-unity.png";
import AustralianWideBank from "../assets/icons/bank/auswide-bank.png";
import BankFirst from "../assets/icons/bank/bank-first.png";
import BankOfAustralia from "../assets/icons/bank/bank-of-australia.png";
import BankOfChina from "../assets/icons/bank/bank-of-china.png";
import BankOfMelbourne from "../assets/icons/bank/bank-of-melbourne.png";
import BankOfUs from "../assets/icons/bank/bank-of-us.png";
import BankSA from "../assets/icons/bank/bank-sa.png";
import BankVIC from "../assets/icons/bank/bank-vic.png";
import BankImage from "../assets/icons/bank/bank.png";
import BankWest from "../assets/icons/bank/bankwest.png";
import Bendigo from "../assets/icons/bank/bendigo.jpeg";
import BeyondBank from "../assets/icons/bank/beyond-bank.jpeg";
import BNK from "../assets/icons/bank/bnk.png";
import BOQBankOfQueensland from "../assets/icons/bank/boq-bank-of-queensland.jpeg";
import BorderBank from "../assets/icons/bank/border-bank.png";
import CitiBank from "../assets/icons/bank/citibank.png";
import CBA from "../assets/icons/bank/commonwealth-CBA.png";
import DefenceBank from "../assets/icons/bank/defence-bank.png";
import DelphiBank from "../assets/icons/bank/delphi.jpeg";
import EndeavourMutual from "../assets/icons/bank/endeavour-mutual.jpeg";
import Esanda from "../assets/icons/bank/esanda.gif";
import Firefighters from "../assets/icons/bank/firefighters-mutual-bank.png";
import FirstOptionBank from "../assets/icons/bank/first-option-bank.png";
import GatewayBank from "../assets/icons/bank/gateway-bank-ltd.png";
import GAndCBank from "../assets/icons/bank/gc-bank.png";
import GeelongBank from "../assets/icons/bank/geelong-bank.png";
import GreaterBank from "../assets/icons/bank/greater-bank.png";
import HorizonBank from "../assets/icons/bank/horizon-bank.png";
import HSBC from "../assets/icons/bank/hsbc.jpeg";
import HumeBank from "../assets/icons/bank/hume-bank.png";
import IMBBank from "../assets/icons/bank/imb-bank.png";
import INGBank from "../assets/icons/bank/ing-bank.png";
import JudoBank from "../assets/icons/bank/judo-bank.png";
import MystateBank from "../assets/icons/bank/mystate-bank.png";
import PAndNBank from "../assets/icons/bank/pn-bank.png";
import PoliceBank from "../assets/icons/bank/police-bank.jpeg";
import QudosBank from "../assets/icons/bank/qudos-bank.png";
import RaboBank from "../assets/icons/bank/rabobank.png";
import RACQBank from "../assets/icons/bank/racq-bank.png";
import RegionalAustralianBank from "../assets/icons/bank/regional-australia-bank-ltd.jpeg";
import RelianceBank from "../assets/icons/bank/reliance-bank.png";
import RSLMoneyBank from "../assets/icons/bank/rsl-money.png";
import RuralBank from "../assets/icons/bank/rural-bank.jpeg";
import ServiceOneBank from "../assets/icons/bank/serivce-one-alliance-bank.png";
import StGeorge from "../assets/icons/bank/st-george-bank.jpeg";
import Suncorp from "../assets/icons/bank/suncorp.jpeg";
import SydneyBank from "../assets/icons/bank/sydney-mutual.jpeg";
import TeachersMutualBank from "../assets/icons/bank/teachers-mutual-bank-ltd.png";
import UBank from "../assets/icons/bank/ubank.png";
import UnityBank from "../assets/icons/bank/unity-bank.png";
import VoltBank from "../assets/icons/bank/volt-bank.png";
import Westpac from "../assets/icons/bank/westpac.jpeg";
import WoolworthsBank from "../assets/icons/bank/woolworths-team-bank-limited.jpeg";
import XinjaBank from "../assets/icons/bank/xinja-bank.jpeg";

export const banks = [
  {
    label: "ANZ",
    value: "anz",
    img: ANZ
  },
  {
    label: "Bank West",
    value: "bankwest",
    img: BankWest
  },
  {
    label: "Bendigo",
    value: "bendigo",
    img: Bendigo
  },
  {
    label: "BOQ Bank Of Queensland",
    value: "boq_bank_of_queensland",
    img: BOQBankOfQueensland
  },
  {
    label: "Commonwealth Bank Australia",
    value: "commonwealth_CBA",
    img: CBA
  },
  {
    label: "Citi Bank",
    value: "citibank",
    img: CitiBank
  },
  {
    label: "HSBC",
    value: "hsbc",
    img: HSBC
  },
  {
    label: "ING Bank",
    value: "ing_bank",
    img: INGBank
  },
  {
    label: "Macquarie",
    value: "macquarie",
    img: Macquarie
  },
  {
    label: "NAB Bank",
    value: "nab_bank",
    img: NABBank
  },
  {
    label: "P&N Bank",
    value: "p&n_bank",
    img: PAndNBank
  },
  {
    label: "Robo Bank",
    value: "robobank",
    img: RaboBank
  },
  {
    label: "St George",
    value: "st_george_bank",
    img: StGeorge
  },
  {
    label: "Suncorp",
    value: "suncorp",
    img: Suncorp
  },
  {
    label: "UBank",
    value: "ubank",
    img: UBank
  },
  {
    label: "Westpac",
    value: "westpac",
    img: Westpac
  },
  {
    label: "AMP Bank",
    value: "amp_bank",
    img: AMPBank
  },
  {
    label: "Australian Military Bank",
    value: "australian_military_bank",
    img: AustralianMilitaryBank
  },
  {
    label: "Australian Unity Bank",
    value: "australian_unity_bank",
    img: AustralianUnityBank
  },
  {
    label: "Australian Mutual Bank",
    value: "australian_mutual_bank",
    img: AustralianMutualBank
  },
  {
    label: "Auswide Bank",
    value: "auswide_bank",
    img: AustralianWideBank
  },
  {
    label: "Bank First",
    value: "bank_first",
    img: BankFirst
  },
  {
    label: "Bank of Us",
    value: "bank_of_us",
    img: BankOfUs
  },
  {
    label: "Bank Australia",
    value: "bank_autralia",
    img: BankOfAustralia
  },
  {
    label: "Bank of Melbourne",
    value: "bank_of_melbourne",
    img: BankOfMelbourne
  },
  {
    label: "BankSA",
    value: "banksa",
    img: BankSA
  },
  // {
  //   label: "Bankwest",
  //   value: "bankwest",
  //   img: BankImage,
  // },
  {
    label: "BankVic",
    value: "bankvic",
    img: BankVIC
  },
  {
    label: "Border Bank (Police Bank)",
    value: "border_bank",
    img: BorderBank
  },
  {
    label: "BeyondBank Australia",
    value: "beyondbank_australia",
    img: BeyondBank
  },
  {
    label: "BNK Banking",
    value: "bnk_banking",
    img: BNK
  },
  {
    label: "Community Sector Banking",
    value: "community_sector_banking",
    img: BankImage
  },
  {
    label: "Defence Bank",
    value: "defence_bank",
    img: DefenceBank
  },
  {
    label: "Delphi Bank",
    value: "delphi_bank",
    img: DelphiBank
  },
  {
    label: "Endeavour Mutual Bank",
    value: "endeavour_mutual_bank",
    img: EndeavourMutual
  },
  {
    label: "Esanda Financial Corporation",
    value: "esanda_financial_corporation",
    img: Esanda
  },
  {
    label: "Firefighters Mutual Bank",
    value: "firefighters_mutual_bank",
    img: Firefighters
  },
  {
    label: "First Option Bank",
    value: "first_option_bank",
    img: FirstOptionBank
  },
  {
    label: "G&C Mutual Bank",
    value: "g&c_mutual_bank",
    img: GAndCBank
  },
  {
    label: "Gateway Bank",
    value: "gateway_bank",
    img: GatewayBank
  },
  {
    label: "Geelong Bank",
    value: "geelong_bank",
    img: GeelongBank
  },
  {
    label: "Greater Bank",
    value: "greater_bank",
    img: GreaterBank
  },
  {
    label: "Heritage Bank",
    value: "heritage_bank",
    img: BankImage
  },
  {
    label: "Horizon Bank",
    value: "horizon_bank",
    img: HorizonBank
  },
  {
    label: "Hume Bank Limited",
    value: "hume_bank_limited",
    img: HumeBank
  },
  {
    label: "IMB Bank",
    value: "imb_bank",
    img: IMBBank
  },
  {
    label: "Judo Bank Pty Ltd",
    value: "judo_bank_pty_ltd",
    img: JudoBank
  },
  {
    label: "Members Equity Bank",
    value: "members_equity_bank",
    img: MembersEquityBank
  },
  {
    label: "MyState Bank",
    value: "mystate_bank",
    img: MystateBank
  },
  // {
  //   label: "P&N Bank",
  //   value: "p&n_bank",
  //   img: BankImage,
  // },
  {
    label: "Police Bank",
    value: "police_bank",
    img: PoliceBank
  },
  {
    label: "QBank",
    value: "qbank",
    img: BankImage
  },
  {
    label: "Qudos Bank",
    value: "quodos_bank",
    img: QudosBank
  },
  {
    label: "RACQ Bank",
    value: "racq_bank",
    img: RACQBank
  },
  {
    label: "Reliance Bank",
    value: "reliance_bank",
    img: RelianceBank
  },
  {
    label: "Regional Australia Bank",
    value: "regional_australian_bank",
    img: RegionalAustralianBank
  },
  {
    label: "RSL Money",
    value: "rsl_money",
    img: RSLMoneyBank
  },
  {
    label: "Rural Bank",
    value: "rural_bank",
    img: RuralBank
  },
  {
    label: "Service One Alliance Bank",
    value: "service_one_alliance_bank",
    img: ServiceOneBank
  },
  {
    label: "Teachers Mutual Bank",
    value: "teachers_mutual_bank",
    img: TeachersMutualBank
  },
  {
    label: "Sydney Mutual Bank",
    value: "sydney_mutual_bank",
    img: SydneyBank
  },
  {
    label: "Volt Bank",
    value: "volt_bank",
    img: VoltBank
  },
  {
    label: "Unity Bank",
    value: "unity_bank",
    img: UnityBank
  },
  {
    label: "Xinja",
    value: "xinja",
    img: XinjaBank
  },
  {
    label: "Woolworths Team Bank",
    value: "woolworths_team_bank",
    img: WoolworthsBank
  },
  {
    label: "Arab Bank Australia",
    value: "arab_bank_australia",
    img: ArabBank
  },
  {
    label: "Bank of China (Australia)",
    value: "bank_of_china_australia",
    img: BankOfChina
  },
  {
    label: "Bank of Sydney",
    value: "bank_of_sydney",
    img: BankImage
  }
];
